<template>
    <router-link tag="div" :to="{name: 'rocket', params: {id: rocket.rocket_id, rocket: rocket} }" class="rocket-card">
        <div class="rocket-card__image">
            <img :src="'https://img.gs/rkbzmnfzcp/quality=low/' + rocket.flickr_images[0]" v-on:load="imageLoaded()" class="img img--bg" alt="">
        </div><!-- /.card__patch -->
        <div class="rocket-card__content">
            <div class="rocket-card__title">
                <h2>{{rocket.rocket_name}}</h2>
                <p>{{rocket.description.substring(0, 120)}}...</p>
                <span class="rocket-card__label" :class=" rocket.active ? '' : 'rocket-card__label--not-active'">
                    {{rocket.active ? 'Active' : 'Not Active'}}
                </span><!-- /.rocket-card__label -->
                <div class="rocket-card__icons">
                    <div class="rocket-card__icon">
                        <span class="rocket-card__icon-label">
                            Cost Per Launch:
                        </span>
                        <span class="rocket-card__icon-value">
                            ${{rocket.cost_per_launch.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                        </span>
                    </div><!-- /.rocket-card__icon -->
                    <div class="rocket-card__icon">
                        <span class="rocket-card__icon-label">
                            Success Rate: 
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.success_rate_pct}}%
                        </span>
                    </div><!-- /.rocket-card__icon -->    
                    <div class="rocket-card__icon">
                        <span class="rocket-card__icon-label">
                            First Stage Engines: 
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.first_stage.engines}}
                        </span>
                    </div><!-- /.rocket-card__icon -->
                    <div class="rocket-card__icon">
                        <span class="rocket-card__icon-label">
                            Second Stage Engines: 
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.second_stage.engines}}
                        </span>
                    </div><!-- /.rocket-card__icon -->
                </div><!-- /.rocket-card__icons -->
            </div><!-- /.rocket-card__title -->    
        </div><!-- /.rocket-card__content -->
    </router-link><!-- /.card -->
</template>

<script>
import objectFitImages from 'object-fit-images'
export default {
    name: 'RocketCard',
    props: {
        rocket: Object
    },
    data() {
        return {

        }
    },
    mounted() {
        
    },
    methods: {
        imageLoaded() {
            objectFitImages('.img--bg');
            $('.img--bg').addClass('loaded');
            console.log('loaded');
        }
    }
}
</script>
